import React from 'react';
import classNames from 'classnames';

const HorizontalPositionSettings = (props) => {
  const horizontal = props.position.value.split(' ')[0];
  const isActive = (val) => val === horizontal;

  const optionClasses = (val) => {
    return classNames(
      'btn btn-form',
      { 'active': isActive(val) }
    );
  };
  const handleChange = (val) => {
    const { onChange, position: { field } } = props;
    const vertical = props.position.value.split(' ')[1];
    const newValue = [val, vertical].join(' ').trim();
    onChange(field, newValue);
  };
  const { options = ['left', 'center', 'right'] } = props;
  const renderOption = (value, index) => (
    <button
      className={optionClasses(value)}
      onClick={() => handleChange(value)}
      key={`position-y--${index}`}
    >
      <div className={`fi fi-ha-${value}`}></div>
    </button>
  );
  return (
    <div className="btn-group">
      {options.map(renderOption)}
    </div>
  );
};

export default HorizontalPositionSettings;
